import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  /* existing field styles */
  selectField: { height: 32 },
  inputRoot: {
    height: 32,
    padding: '5px 8px 6px 8px',
    borderRadius: 4,
    color: 'rgba(95, 96, 113, 1)',
    backgroundColor: '#fff',
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid rgba(213, 214, 221, 1)',
    },
  },

  /* container + grid item */
  containerPadding: { padding: 24, boxSizing: 'border-box' },
  titleRow: { marginBottom: 10 },
  fieldItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    padding: 0,
    paddingRight: 8,
    paddingBottom: 5,
    boxSizing: 'border-box',
    minWidth: 0, // IMPORTANT for ellipsis inside flex/grid
  },

  /* ellipsis + width constraints */
  blockTitle: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '12px',
    color: 'rgba(43, 44, 53, 1)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    minWidth: 320, // default ≥1920px
  },
  fieldLabel: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '17px',
    color: 'rgba(120, 121, 142, 1)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    minWidth: 260, // default ≥1920px
  },
  helperText: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '17px',
    color: 'rgba(175, 176, 191, 1)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    minWidth: 260, // default ≥1920px
  },

  /* ===== breakpoints: static min-width per screen size ===== */
  '@media (max-width:1600px)': {
    containerPadding: { padding: 20 },
    blockTitle: { minWidth: 300 },
    fieldLabel: { minWidth: 240 },
    helperText: { minWidth: 240 },
  },
  '@media (max-width:1366px)': {
    blockTitle: { minWidth: 260 },
    fieldLabel: { minWidth: 220 },
    helperText: { minWidth: 220 },
  },
  '@media (max-width:1280px)': {
    containerPadding: { padding: 16 },
    blockTitle: { minWidth: 220, fontSize: 13, lineHeight: '14px' },
    fieldLabel: { minWidth: 200, fontSize: 11 },
    helperText: { minWidth: 200, fontSize: 11 },
  },
  '@media (max-width:1024px)': {
    blockTitle: { minWidth: 180, fontSize: 12 },
    fieldLabel: { minWidth: 170 },
    helperText: { minWidth: 170 },
  },
}));

export default useStyles;
